var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoverScreenLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 529,
    height: 700,
    viewBox: "0 0 529 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444 17.0634H0V674.063H444V17.0634Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 691.063L0 674.063V17.063L323 0.0629883V691.063Z",
    fill: "#ea580c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 381.063C298.209 381.063 300 379.273 300 377.063C300 374.854 298.209 373.063 296 373.063C293.791 373.063 292 374.854 292 377.063C292 379.273 293.791 381.063 296 381.063Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 377.66L298.773 382.463L301.545 387.265H296H290.455L293.227 382.463L296 377.66Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337 691.063L317.217 691L318 0.0629883H337V691.063Z",
    fill: "#ea580c"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M337.217 691H317.217L318.217 0H337.217V691Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M296 361.063C303.18 361.063 309 355.243 309 348.063C309 340.884 303.18 335.063 296 335.063C288.82 335.063 283 340.884 283 348.063C283 355.243 288.82 361.063 296 361.063Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 359.063C303.18 359.063 309 353.243 309 346.063C309 338.884 303.18 333.063 296 333.063C288.82 333.063 283 338.884 283 346.063C283 353.243 288.82 359.063 296 359.063Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M52.8194 16.108V677.156",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M109.819 12.108V679.156",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M166.819 9.108V683",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M223.819 6.108V687.156",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M280.819 3.108V688",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.217 132.323C485.032 132.323 502.717 115.758 502.717 95.3234C502.717 74.8889 485.032 58.3234 463.217 58.3234C441.402 58.3234 423.717 74.8889 423.717 95.3234C423.717 115.758 441.402 132.323 463.217 132.323Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.217 325.823L338.217 339.823C338.217 339.823 290.217 349.823 308.217 364.823C326.217 379.823 352.217 350.823 352.217 350.823L366.217 332.823L348.217 325.823Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.217 166.823C400.217 166.823 387.217 166.823 384.217 184.823C381.217 202.823 378.217 262.823 378.217 262.823C378.217 262.823 336.217 317.823 343.217 324.823C350.217 331.823 358.217 344.823 363.217 342.823C368.217 340.823 411.217 281.823 411.217 281.823L400.217 166.823Z",
    fill: "#FD4D05"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M400.217 166.823C400.217 166.823 387.217 166.823 384.217 184.823C381.217 202.823 378.217 262.823 378.217 262.823C378.217 262.823 336.217 317.823 343.217 324.823C350.217 331.823 358.217 344.823 363.217 342.823C368.217 340.823 411.217 281.823 411.217 281.823L400.217 166.823Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.217 115.823C440.217 115.823 439.217 154.823 427.217 156.823C415.217 158.823 419.217 171.823 419.217 171.823C419.217 171.823 458.217 194.823 484.217 171.823L489.217 159.823C489.217 159.823 471.217 146.823 479.217 128.823L440.217 115.823Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.217 355.823C373.217 355.823 314.217 465.823 336.217 499.823C358.217 533.823 391.217 603.823 396.217 603.823C401.217 603.823 429.217 589.823 427.217 580.823C425.217 571.823 395.217 504.823 387.217 498.823C379.217 492.823 383.217 476.823 384.217 475.823C385.217 474.823 418.217 421.823 418.217 421.823C418.217 421.823 417.217 505.823 421.217 518.823C425.217 531.823 420.217 624.823 425.217 628.823C430.217 632.823 453.217 639.823 457.217 633.823C461.217 627.823 473.217 536.823 465.217 515.823L480.217 371.823L373.217 355.823Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.217 622.823L402.217 668.823C402.217 668.823 366.217 694.823 391.217 698.823C416.217 702.823 431.217 692.823 431.217 692.823L453.217 676.823V630.823L427.217 622.823Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.217 596.823L406.217 627.823C406.217 627.823 411.217 640.823 406.217 643.823C401.217 646.823 387.217 664.823 396.217 666.823C398.028 667.178 399.868 667.361 401.713 667.37C409.207 667.496 416.649 666.104 423.592 663.279C430.534 660.454 436.833 656.254 442.11 650.93L450.217 642.823C450.217 642.823 422.447 578.875 422.832 579.349C423.217 579.823 393.217 596.823 393.217 596.823Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.217 139.823C483.995 139.823 499.217 124.601 499.217 105.823C499.217 87.0457 483.995 71.8234 465.217 71.8234C446.44 71.8234 431.217 87.0457 431.217 105.823C431.217 124.601 446.44 139.823 465.217 139.823Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.717 153.323L474.217 163.823C474.217 163.823 442.217 175.823 427.217 163.823C427.217 163.823 432.717 152.323 432.717 153.323C432.717 154.323 389.217 160.823 385.217 178.823C381.217 196.823 388.217 227.823 388.217 227.823C388.217 227.823 360.217 359.823 371.217 362.823C382.217 365.823 485.217 390.823 484.217 371.823C483.217 352.823 492.217 274.823 492.217 274.823L527.217 207.823C527.217 207.823 522.217 185.823 510.217 178.823C498.217 171.823 484.717 153.323 484.717 153.323Z",
    fill: "#FD4D05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.217 348.823L427.217 356.823C427.217 356.823 377.217 390.823 403.217 396.823C429.217 402.823 444.217 372.823 444.217 372.823L454.217 360.823L440.217 348.823Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M514.217 201.823L523.217 210.823C523.217 210.823 529.217 294.823 517.217 311.823C505.217 328.823 450.217 374.823 447.217 371.823C444.217 368.823 425.217 353.823 429.217 351.823C433.217 349.823 486.4 294.254 486.4 294.254L482.217 216.823L514.217 201.823Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.217 198.823L527.217 207.823C527.217 207.823 533.217 291.823 521.217 308.823C509.217 325.823 454.217 371.823 451.217 368.823C448.217 365.823 429.217 350.823 433.217 348.823C437.217 346.823 490.4 291.254 490.4 291.254L486.217 213.823L518.217 198.823Z",
    fill: "#FD4D05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.156 57.5286C451.156 57.5286 439.598 53.3258 423.838 62.2566L432.243 64.358C432.243 64.358 419.635 65.4087 418.059 82.2196H423.838C423.838 82.2196 420.16 96.9291 423.838 101.132L426.202 96.6665L433.031 110.325L434.607 103.496L437.759 104.547L439.861 93.5144C439.861 93.5144 445.114 101.395 449.317 101.92V95.0904C449.317 95.0904 460.874 108.224 464.552 107.699L459.298 100.344L466.653 101.92L463.501 96.6664L482.413 101.92L478.211 96.6664L491.344 100.869L497.648 103.496C497.648 103.496 506.579 83.0076 493.971 68.8234C481.363 54.6392 462.976 51.4871 451.156 57.5286Z",
    fill: "#2F2E41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 528.717,
    height: 699.768,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverScreenLogin);
export default __webpack_public_path__ + "static/media/CoverScreenLogin.8f08135956c5f0ab8d68ecc105a99a5f.svg";
export { ForwardRef as ReactComponent };